import addClientUseCase from "clients/services/addClientUseCase";
import BusEvent from "common/services/BusEvent";
import { findClientByDNI } from "clients/api";
import { updateTask } from "tasks/api";

const updateTaskUseCase = async (task, oldTask) => {
  checkIsFinalize(task, oldTask);
  checkIsRepaired(task, oldTask);
  checkIsNotRepaired(task, oldTask);
  checkBudgetAdded(task, oldTask);
  checkBudgetAccepted(task, oldTask);
  checkNotifications(task, oldTask);

  return updateTask(task)
    .then(() => BusEvent.publish(BusEvent.UPDATE_TASK, { task, oldTask }))
    .catch(err => console.error(err));
}

export const updateTaskUseCaseByClient = async (task, oldTask) => {
  checkIsFinalize(task, oldTask);
  checkIsRepaired(task, oldTask);
  checkIsNotRepaired(task, oldTask);
  checkBudgetAdded(task, oldTask);
  checkBudgetAccepted(task, oldTask);
  checkNotifications(task, oldTask);
  return updateTask(task);
}

const checkIsFinalize = (newTask, oldTask) => {
    const payedCurrent = parseInt(newTask.payed)
    const payedOld = parseInt(oldTask.payed)

    if (payedCurrent === 1 && payedOld !== 1) {
        newTask.dateFinish = new Date().getTime();
        newTask.collected = 1;
        // NOTA3: al cobrar, marcar automáticamente el presupuesto como aceptado
        newTask.budgetAccept = 1;
        if (!newTask.dateAccepted) {
            newTask.dateAccepted = new Date().getTime();
        }
    }
}

const checkIsRepaired = (newTask, oldTask) => {
  const stateCurrent = parseInt(newTask.state);
  const stateOld = parseInt(oldTask.state);

  if (stateCurrent === 2 && stateOld !== 2) {
    newTask.dateRepaired = new Date().getTime();
  }
}

const checkIsNotRepaired = (newTask, oldTask) => {
  const stateCurrent = parseInt(newTask.state);
  const stateOld = parseInt(oldTask.state);

  if (stateCurrent === 4 && stateOld !== 4) {
    newTask.budget = 0;
    newTask.description = `SIN REPARAR - ${newTask.description || ''}`;
  }
}

// NOTA6.1: si se añade precio estando en "En diagnóstico" → pasa a "Pendiente confirmación cliente"
const checkBudgetAdded = (newTask, oldTask) => {
  const budgetNew = parseFloat(newTask.budget) || 0;
  const budgetOld = parseFloat(oldTask.budget) || 0;
  if (budgetNew > 0 && budgetOld === 0 && parseInt(newTask.state) === 0) {
    newTask.state = 6; // Pendiente confirmación cliente
  }
}

// NOTA6.2: si se acepta el presupuesto estando en "Pendiente confirmación cliente" → pasa a "Reparando"
// También guarda la fecha de aceptación siempre que se marque el tick por primera vez
const checkBudgetAccepted = (newTask, oldTask) => {
  if (parseInt(newTask.budgetAccept) === 1 && parseInt(oldTask.budgetAccept) !== 1) {
    newTask.dateAccepted = newTask.dateAccepted || new Date().getTime();
    if (parseInt(newTask.state) === 6) {
      newTask.state = 5; // Reparando
    }
  }
}

const checkNotifications = (newTask, oldTask) => {
  const newState = parseInt(newTask.state);
  const oldState = parseInt(oldTask.state);
  if (newState === oldState) return;

  if (newState === 2) {
    newTask.notifyReparado = true;
  } else {
    newTask.notifyReparado = false;
  }

  if (newState === 6 && newTask.notifyPresupuesto !== false) {
    newTask.notifyPresupuesto = true;
  } else if (newState !== 6) {
    newTask.notifyPresupuesto = false;
  }
}

export default updateTaskUseCase